import { useTranslation } from 'react-i18next';
import { type StandardApplicationModuleSpecsFragment } from '../../../../api/fragments/StandardApplicationModuleSpecs';
import ApplicationModuleFinanceProductAssignments from '../shared/ApplicationModuleFinanceProductAssignments';

export type UpdateFinanceProductAssignmentsValue = {
    dealerFinanceProducts: Record<string, string[]>;
};

export type FinanceProductAssignmentsProps = {
    module: StandardApplicationModuleSpecsFragment;
};

const FinanceProductAssignments = ({ module }: FinanceProductAssignmentsProps) => {
    const { t } = useTranslation(['eventApplicationModuleDetails']);

    return (
        <ApplicationModuleFinanceProductAssignments
            module={module}
            noItemText={t('eventApplicationModuleDetails:tabs.financeProducts.noData')}
        />
    );
};

export default FinanceProductAssignments;
